// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Edxc","box":"WorkspacesBox_box__2BcaX","node":"WorkspacesBox_node__1t96M"};